const getPrices = (pricesArr = []) => {
    const monthlyPrice = pricesArr.find(d => d.BillingPeriod === 'MONTH');
    const annualPrice = pricesArr.find(d => d.BillingPeriod === 'YEAR');
    return {
        monthlyPrice,
        annualPrice
    };
};

export default getPrices;
